import {
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_CLEAR,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_REQUEST,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_SUCCESS,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_FAILURE,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_CLEAR,
  FETCH_SINGLE_KEG_COLLECTION_BOOKING_QUEUE
)
